import { Dashboard } from "./Dashboard";
import { useTenant } from "../shell";
import { useSession } from "../session";
import { Notice } from "../components";
import { Link } from "../router";


export function Home() {
  const { me } = useSession();
  const { can } = useTenant();
  return (
    <>
      <div className="page-head"><h1>Welcome, {me!.user.fullName}</h1>
        <div className="form-actions inline">
          {can("patient:create") && <Link to="/app/patients/new" className="btn btn-primary">Register a patient</Link>}
          {can("appointment:create") && <Link to="/app/appointments/new" className="btn btn-secondary">Book appointment</Link>}
        </div></div>
      {!me!.mfa && can("settings:edit") && <Notice tone="info">Protect your account: two-step verification is recommended for administrators. <Link to="/app/profile">Turn it on in your profile</Link>.</Notice>}
      <Dashboard />
    </>
  );
}
